import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from '../images/transition4.json';

const Transition4Animation = () => {
  return (
    <div style={{ width: '250px'}}>
      <Player
        autoplay
        loop
        src={animationData}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default Transition4Animation;